import React, { ChangeEvent, FormEvent, useEffect, useState } from "react";
import { connect, useSelector } from "react-redux";
import { ApiError } from "components";
import { UploadAvatar } from "./component/UploadAvatar";
import { createCheyCheyImage } from "../store/action";
import { title } from "process";

interface CreateImageProps {
  closeModal: React.Dispatch<React.SetStateAction<boolean>>;
}
export interface imageError {
  image?: string; 
}
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = DispatchProps & CreateImageProps & imageError ;

const CreateImage: React.FC<Props> = ({ closeModal, onCreateAvatar }) => {
  const [formData, setFormData] = useState({
    image: "",
    type:"",
    title: "",
    category: "",
  });
  const [imageFile, setImageFile] = useState<File | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<imageError>({});
  const [apiError, setApiError] = useState(null);
  const [submitted, setSubmitted] = useState(false);
  const cheyCheyImageState = useSelector(
    (state: any) => state.cheyCheyImageReducer.cheyCheyImageState
  );
  const handleChange = (e: ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value, type } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === "number" ? Number(value) : value,
    }));
    setError((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  const handleSave = async (e: FormEvent) => {
    e.preventDefault();
    if (!imageFile) {
    setError({ image: "Please select an image to upload." });
    return;
  }
    let uploadedFilename: string | undefined = undefined;
    if (imageFile) {
      const uploadUrl = `${process.env.REACT_APP_CHEYCHEY_UPLOAD_BASE_URL}`;
      const form = new FormData();
      form.append("file", imageFile);
      const response = await fetch(uploadUrl ?? "", {
        method: "POST",
        body: form,
      });
      if (!response.ok) {
        const errorText = await response.text();
        console.error("Upload failed:", errorText);
        throw new Error("Failed to upload image");
      }
      const result = await response.json();
      uploadedFilename = result?.imageURL;

      if (!uploadedFilename) {
        console.error("Image upload response invalid", result);
        throw new Error("Image upload response invalid");
      }
    }
      if (uploadedFilename) {
        formData.image = uploadedFilename;
      }
      setLoading(true);
      onCreateAvatar(formData.image, formData.type, formData.title, formData.category);
      setSubmitted(true);
      setLoading(false);
  };
  useEffect(() => {
    if (!cheyCheyImageState.isLoading && submitted) {
      if (cheyCheyImageState.error) {
        setApiError(cheyCheyImageState.error); 
      } else {
        setApiError(null);
        closeModal(false);
      }
    }
  }, [cheyCheyImageState.isLoading, cheyCheyImageState.error, submitted]);
  return (
    <>
      <UploadAvatar
        header="Upload Image"
        formData={formData}
        error={error}
        handleChange={handleChange}
        handleSubmit={handleSave}
        loading={loading}
        handleImageFileChange={setImageFile}
      />
      {apiError && <ApiError>{apiError}</ApiError>}
    </>
  );
};
const mapDispatchToProps = (dispatch: any) => ({
  onCreateAvatar: (image:string, type:string, title:string, category:string) => dispatch(createCheyCheyImage(image, type, title, category)),
});

export default connect(null, mapDispatchToProps)(CreateImage);
